import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { Fade } from '../atoms/Fade';
import { Overlay } from '../atoms/Overlay';
import { ClosableBox } from '../molecules/ClosableBox';

const styles = {
  defaultClosableBoxPositioning: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
  `
};

export const Modal = React.forwardRef(
  (
    {
      show,
      closeCb,
      closeText,
      overlayColor,
      closableBoxPositioningStyles,
      closeIconPosition,
      children
    },
    ref
  ) => {
    useEffect(() => {
      // Dispatch an event before adding the event listener, to avoid closing
      // the same modal we are currently opening. This way, only previously open
      // modals will get closed.
      if (show) {
        window.dispatchEvent(new CustomEvent('modal-open'));
      }
      window.addEventListener('modal-open', closeCb);
      return () => window.removeEventListener('modal-open', closeCb);
    }, [show]);

    return (
      <Fade show={show} position="relative" zIndex="999">
        <Overlay color={overlayColor} ref={ref}>
          <ClosableBox
            styles={
              closableBoxPositioningStyles ||
              styles.defaultClosableBoxPositioning
            }
            closeCb={closeCb}
            closeText={closeText}
            closeIconPosition={closeIconPosition}
          >
            {children}
          </ClosableBox>
        </Overlay>
      </Fade>
    );
  }
);

Modal.defaultProps = {
  closeText: undefined,
  overlayColor: undefined,
  closableBoxPositioningStyles: undefined,
  closeIconPosition: {}
};

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  closeCb: PropTypes.func.isRequired,
  closeText: PropTypes.string,
  overlayColor: PropTypes.string,
  closableBoxPositioningStyles: PropTypes.objectOf(PropTypes.any),
  closeIconPosition: PropTypes.objectOf(PropTypes.any),
  children: PropTypes.node.isRequired
};
